/**
    红包
**/
<template>
  <div style="width: 1200px; margin: 30px auto">
    <div class="orderSuccess">
      <el-row>
        <el-col :span="3"
          ><i class="el-icon-check orderSuccess_icon"></i
        ></el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="24" class="orderSuccess_tip">
              <span class="orderSuccess_text">订单提交成功！去付款咯～</span>
              <span
                >应付总额：<i class="orderSuccess_price">￥{{
                  totalAmount || 0
                }}</i></span>

            </el-col>
            <el-col :span="24" class="orderSuccess_tip" v-if="offlinePayMoney > 0">
              <span>线下支付订单</span>
              <span><i>(已减去线下支付订单的金额：¥{{ offlinePayMoney }})</i></span>
            </el-col>
            <el-col :span="24">
              <el-collapse>
                <el-collapse-item name="1">
                  <template slot="title">
                    签收须知：请您与快递一起当面拆箱验货<i class="order_detail"
                      >订单详情</i
                    >
                  </template>
                  <div v-for="(item, index) in orderGoodsInfo" :key="index">
                    <div style="margin-bottom: 15px">
                      <span class="text_width">订单号：</span>
                      <span class="text_bgcolor">{{ item.orderNumber }}</span>
                    </div>
                    <!-- 这个地址需要后期转换,暂时这样写 -->
                    <!-- <span>{{item.nameArr}}---------1</span> -->
                    <div style="margin-bottom: 15px">
                      <span class="text_width">收货信息：</span>
                      <span class="text_bgcolor"
                        >
                        {{ item.recipient }} &nbsp;
                        {{ item.phoneNumber }} &nbsp;
                        {{ item.areaName }} &nbsp;
                        {{ item.address }} &nbsp;
                        {{ item.postalCode }}
                      </span>
                    </div>
                    <div style="margin-bottom: 15px">
                      <span class="text_width">商品名称：</span>
                      <span class="text_bgcolor">{{ item.title }}</span>
                      <span v-for="item1 in item.nameArr" :key="item1">
                        {{ item1 }}
                      </span>
                    </div>
                    <!-- <div style="margin-bottom: 15px;"><span class="text_width">配送时间：</span> <span class="text_bgcolor"></span></div>
                                            <div style="margin-bottom: 15px;"><span class="text_width">发票信息：</span> <span class="text_bgcolor"></span></div> -->
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-col>
            <!-- 这个地址需要后期转换,后期开放 -->
            <!-- <el-col :span="24" class="address_info">
                                <span>收货信息: </span>
                                <span> qaz  131***6543    重庆市  重庆市   万州区  qaz</span>
                            </el-col> -->
          </el-row>
        </el-col>
      </el-row>
      <div class="payMethods">
        <!-- 这个,后期开放 -->
        <div class="payMethods_title">选择以下支付方式付款</div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
        >
         <!-- <div v-if="!isDealer">
            <p>站内支付 余额</p>
            <div class="checked_free">
              <el-checkbox v-model="checked" @change="changeCheck()"
              >使用预存款支付（可用余额：￥{{
                getUserPays.userMoney
                }}）</el-checkbox
              > -->
              <!-- <span>可用余额不足</span> -->
              <!-- <el-form-item
                v-show="checked"
                label="输入支付密码 :"
                prop="pass"
                style="width: 40%; margin: 20px 0"
              >
                <el-input
                  type="password"
                  v-model="ruleForm.pass"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </div>
          </div> -->
        <!--     非经销商支付方式     -->
          <el-form-item v-if="!isDealer">
            <p style="font-size: 20px">选择在线支付</p>
            <el-radio
              v-model="ruleForm.radio"
              label="1"
              @change="changeCheckRadio()"
              ><el-image
                class="payMethods_img"
                :src="require('@/assets/img/alipay.png')"
              ></el-image
            ></el-radio>
            <el-radio
              v-model="ruleForm.radio"
              label="2"
              @change="changeCheckRadio()"
              ><el-image
                class="payMethods_img"
                :src="require('@/assets/img/wx_native.png')"
              ></el-image
            ></el-radio>
<!--            <el-radio-->
<!--              v-model="ruleForm.radio"-->
<!--              label="3"-->
<!--              @change="changeCheckRadio()"-->
<!--            >-->
              <!--     20241015林君茜     -->
<!--              <el-button plain style="width: 174px;height: 61px;border: 1px solid #ccc;padding: 0;border-radius: 0">-->
<!--              <div style="font-weight: bold;height: 50%;font-size: 18px;padding-top: 10px">二维码支付</div>-->
<!--              <div style="background-color: #E53935;color: #eee;height: 32%;font-size: 12px;line-height: 120%">通用二维码支付</div>-->
<!--            </el-button>-->
<!--            </el-radio>-->
          </el-form-item>
          <!--    经销商支付方式      -->
          <el-form-item v-if="isDealer">
            <p style="font-size: 20px">选择银行转账</p>
            <el-radio
              v-model="ruleForm.radio"
              label="4"
              @change="changeCheckRadio()"
            ><el-button plain style="width: 174px;height: 61px;border: 1px solid #ccc;padding: 0;border-radius: 0">
              <div style="font-weight: bold;height: 50%;font-size: 18px;padding-top: 10px">银行转账</div>
              <div style="background-color: #E53935;color: #eee;height: 32%;font-size: 12px;line-height: 120%">通用银行转账</div>
            </el-button>
            </el-radio>
          </el-form-item>

          <!-- 快捷通 支付 开始-->
          <el-form-item v-if="kjtEnableObj.enable&&kjtEnableObj.merchant">
              <el-collapse accordion  v-model="openfastPay">
                <el-collapse-item title="选择快捷通支付" name="1">
                  <template slot="title">
                    <el-checkbox v-model="fastChecked" @change="changeFastCheck()"><span style="font-size:14px">选择快捷通支付</span></el-checkbox>
                </template>
                <div>
                  <el-menu
                  :default-active="navList[0].navId"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                >
                  <template v-for="(item, index) in navList">
                    <el-menu-item  :index="item.navId" :key="index" router="true">
                      <i >
                        {{ item.name }}
                      </i>
                    </el-menu-item>
                  </template>
                </el-menu>
                <el-radio-group v-model="modeKey"  v-for="(item, index) in bankLists[index]" :key="index">
                  <el-radio style="margin-top:20px;margin-left:20px;"
                    :label="item.radio"
                    @change="changeBack(item,index)"
                  >
                    {{ item.bank }}
                  </el-radio>
                </el-radio-group>
                </div>
                <div class="fastPay" style="display: flex;justify-content: space-between;margin-top: 30px;">
                  <div style="line-height: 60px;color: #78b942;">支付金额：￥{{ totalAmount || 0 }}</div>
                  <el-button size="mini" @click="wangYing" type="primary" class="buttonBgd">网银支付</el-button>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <!-- 快捷通 支付 结束-->

          <!-- 扫码 支付 结束-->
          <!-- <view>{{kjtEnableObj.H5}}==={{kjtEnableObj.merchant}}====={{kjtEnableObj.H5&&kjtEnableObj.merchant}}</view> -->
          <el-form-item v-if="kjtEnableObj.enable&&kjtEnableObj.H5&&kjtEnableObj.merchant">
              <el-collapse accordion  v-model="opencodePay">
                <el-collapse-item title="扫码支付" name="1">
                  <template slot="title">
                    <el-checkbox v-model="codeChecked" @change="changecodeCheck()"><span style="font-size:14px">扫码支付</span></el-checkbox>
                </template>
                <div style="text-align:center;">
                    <p style="font-size: 18px;margin-bottom: 8px;">支付宝/微信</p>
                    <div><div style="display:inline-block;" id="qrcode" ref="qrcode"></div></div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <!-- 如果是快捷通 就不展示 -->
          <el-form-item v-if="(!openfastPay)&&(!opencodePay)">
            <div v-if="orderGoodsInfo[0].orderType === 5">支付金额：￥{{ unPayMoney || 0 }}</div>
            <div v-else>支付金额：￥{{ totalAmount || 0 }}</div>
            <el-button type="primary"  @click="orderNows" class="buttonBgd"
              >确定支付</el-button
            >
            <!-- 后续打开 -->
            <!-- <el-button
              style="margin-left: 20px"
              type="primary"
              @click="orderNowsmix"
              class="buttonBgd"
              >混合支付</el-button> -->
          </el-form-item>
        </el-form>
      </div>

      <!-- 付款后的的弹框 -->
      <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        center
        class="dialogBox"
      >
        <div class="textCenter">付款成功, 继续查看订单详情！</div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="$router.push('/myOrderDetail')"
            class="buttonBgd"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <el-dialog
      :visible.sync="dialogVisibles"
      width="30%"
      center
      class="dialogBox"
    >
      <div class="textCenter" v-html="payPage"></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="$router.push('/myOrderDetail')"
          class="buttonBgd"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 点击混合支付的弹出框 -->
    <el-dialog
      title="组合方式"
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      width="30%"
      class="mixdialog"
      center
    >
      <div>当前可用余额：￥{{ getUserPays.userMoney }}</div>
      <el-input
        :placeholder="`请输入余额支付的金额，金额不能超过${balanceRatioPrice.toFixed(
          2
        )}`"
        v-model="balencePay"
        autocomplete.native="off"
      ></el-input>
      <div style="margin-top: 20px">请输入支付密码</div>
      <el-input
        type="password"
        v-model="ruleForm.pass"
        placeholder="请输入支付密码"
        autocomplete.native="off"
      ></el-input>
      <!-- 支付宝支付和微信支付 -->
      <div class="mixPayed">
        <el-radio
          v-model="ruleForm.radio"
          label="3"
          @change="changeCheckRadio()"
          ><el-image
            class="payMethods_img"
            :src="require('@/assets/img/alipay.png')"
          ></el-image
        ></el-radio>
        <el-radio
          v-model="ruleForm.radio"
          label="4"
          @change="changeCheckRadio()"
          ><el-image
            class="payMethods_img"
            :src="require('@/assets/img/wx_native.png')"
          ></el-image
        ></el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="mixPay" class="buttonBgd"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!--     再次支付弹窗     -->
    <el-dialog
      title="确认支付"
      :visible.sync="payDialogVisible"
      width="30%"
      center
    >
      <div style="font-size: 14px; text-align: left; color: #78b942; margin-top: 10px;">
        <div style="background-color: #f0f9eb; border: 1px solid #e1f3d8; border-radius: 8px; padding: 10px;">
          <span style="color: red;"><strong>温馨提示：</strong></span>
          <br>
          1、订单支付状态同步可能会存在延时，如果支付成功，请稍后查看订单的支付状态
          <br>
          2、订单待支付金额如果小于银行卡单次支付限额的，可以直接填写订单待支付金额。
          <br>
          3、订单待支付金额如果大于银行卡单次支付限额的，请填写银行单次支付限额金额，分多次进行支付。
        </div>
      </div>
      <div style="font-size: 16px; text-align: left; padding: 0 20px; margin-top: 20px;">
        <div>
          <span><strong>待支付金额：</strong><i style="color: #d01717">{{ (unPayMoney || 0).toFixed(2) }}</i> 元</span>
        </div>
        <div style="margin-top: 18px; display: flex; align-items: center;">
          <span><strong>本次支付金额：</strong></span>
          <input type="number" v-model="unPayMoney" autocomplete="off" style="margin-left: 10px;">
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
              <el-button @click="payDialogVisible = false">取 消</el-button>
              <el-button type="primary" class="buttonBgd" @click="payMoneyAgain">确 定</el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import {
  alipay,
  balancePay,
  balancePayMax,
  showorderList,
  getUserPay,
  getSpecificationselect,
  alipayPc,
  alipayPcWX,
  getBalancePayProportion,
  checkPay,
  getZtPay,
  getZtAlipayPcPay,
  paycodeStatus,
  kjtEnable,
  kjtbankList,
  cloudBillOrderPay,
  cloudBillOrderPayMerge,
  cloudBillOrderPayV2
} from "@/api/xunyou";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "" && this.checked == true) {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    return {
      isDealer: false,
      offlinePayMoney: 0,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      orderGoodsInfo:JSON.parse(sessionStorage.getItem("orderGoodsInfo")) || [],
      mergeFlag:JSON.parse(sessionStorage.getItem("mergeFlag")) || "false",
      totalAmount: JSON.parse(sessionStorage.getItem("account")) || 0,
      totalOrderNosMerge : JSON.parse(sessionStorage.getItem("totalOrderNosMerge")) || "",
      account: 0,
      payPage: "",
      checked: true,
      centerDialogVisible: false,
      dialogVisible: false,
      dialogVisibles: false,
      payDialogVisible: false,
      unPayMoney: JSON.parse(sessionStorage.getItem("unPayMoney")) || 0, //支付金额
      balencePay: "",
      ruleForm: {
        pass: "",
        radio: '',
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
      },
      wxAlipay: false,
      // 左侧用户金额
      getUserPays: {},

      balanceRatio: 0, //余额支付比例
      balanceRatioPrice: 0, //余额支付最高额度

      // 快捷通支付
      kjtEnableObj:{},
      codeChecked:false,
      opencodePay:'',//打开二维码折叠面板
      // fastPay:false, //是否是快捷通
      fastChecked:false,//是否是快捷通
      openfastPay:'',//打开银行折叠面板
      zfbAlipay: false,
      activeIndex: '1',
      modeKey: '',
      bankLists:[],
      index:0,
      payProductCode:'20',
      midArr:[],
      cidArr:[],
      bankCode:'',
       navList:[
        {
          name: '借记卡',
          bankList: [
            {
              bank: '农业银行',
              bankCode:'ABC',
              radio: 1
            },
            {
              bank: '工商银行',
              bankCode:'ICBC',
              radio: 2
            },
            {
              bank: '建设银行',
              bankCode:'CCB',
              radio: 3
            },
            {
              bank: '交通银行',
              bankCode:'BCM',
              radio: 4
            },
            {
              bank: '浦发银行',
              bankCode:'CIB',
              radio: 5
            },
            {
              bank: '邮储银行',
              bankCode:'PSBC',
              radio: 6
            },
            {
              bank: '中国银行',
              bankCode:'BOC',
              radio: 7
            },
            {
              bank: '中信银行',
              bankCode:'CICC',
              radio: 8
            },
            {
              bank: '平安银行',
              bankCode:'SZPAB',
              radio: 9
            },
            {
              bank: '光大银行',
              bankCode:'CEB',
              radio: 10
            },
            {
              bank: '华夏银行',
              bankCode:'HXB',
              radio: 11
            },
            {
              bank: '兴业银行',
              bankCode:'CIB',
              radio: 12
            },
            {
              bank: '民生银行',
              bankCode:'CMBC',
              radio: 13
            },
            {
              bank: '北京银行',
              bankCode:'BCCB',
              radio: 14
            },
            {
              bank: '上海银行',
              bankCode:'BOS',
              radio: 15
            },
          ],
          navId: "0",
        },
        {
          name: '信用卡',
          bankList: [
            {
              bank: '农业银行',
              bankCode:'ABC',
              radio: 1
            },
            {
              bank: '工商银行',
              bankCode:'ICBC',
              radio: 2
            },
            {
              bank: '建设银行',
              bankCode:'CCB',
              radio: 3
            },
            {
              bank: '交通银行',
              bankCode:'BCM',
              radio: 4
            },
            {
              bank: '浦发银行',
              bankCode:'CIB',
              radio: 5
            },
            {
              bank: '邮储银行',
              bankCode:'PSBC',
              radio: 6
            },
            {
              bank: '中国银行',
              bankCode:'BOC',
              radio: 7
            },
            {
              bank: '光大银行',
              bankCode:'CEB',
              radio: 8
            },
            {
              bank: '兴业银行',
              bankCode:'CIB',
              radio: 9
            },
            {
              bank: '民生银行',
              bankCode:'CMBC',
              radio: 10
            },
            {
              bank: '平安银行',
              bankCode:'SZPAB',
              radio: 11
            },
            {
              bank: '上海银行',
              bankCode:'BOS',
              radio: 12
            },
            {
              bank: '华夏银行',
              bankCode:'HXB',
              radio: 13
            },
            {
              bank: '北京银行',
              bankCode:'BCCB',
              radio: 14
            },
          ],
          navId: "1",
        },
        {
          name: 'B2B信用卡',
          bankList: [
            {
              bank: '农业银行',
              bankCode:'ABC',
              radio: 1
            },
            {
              bank: '工商银行',
              bankCode:'ICBC',
              radio: 2
            },
            {
              bank: '建设银行',
              bankCode:'CCB',
              radio: 3
            },
            {
              bank: '交通银行',
              bankCode:'BCM',
              radio: 4
            },
            {
              bank: '浦发银行',
              bankCode:'CIB',
              radio: 5
            },
            {
              bank: '邮储银行',
              bankCode:'PSBC',
              radio: 6
            },
            {
              bank: '中国银行',
              bankCode:'BOC',
              radio: 7
            },
            {
              bank: '中信银行',
              bankCode:'CICC',
              radio: 8
            },
            {
              bank: '平安银行',
              bankCode:'SZPAB',
              radio: 9
            },
            {
              bank: '光大银行',
              bankCode:'CEB',
              radio: 10
            },
            {
              bank: '华夏银行',
              bankCode:'HXB',
              radio: 11
            },
            {
              bank: '兴业银行',
              bankCode:'CIB',
              radio: 12
            },
            {
              bank: '民生银行',
              bankCode:'CMBC',
              radio: 13
            },
            {
              bank: '北京银行',
              bankCode:'BCCB',
              radio: 14
            },
            {
              bank: '上海银行',
              bankCode:'BOS',
              radio: 15
            },
          ],
          navId: "2",
        },
      ],
    };
  },

  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    if (this.$route.query.amount){
      this.offlinePayMoney = this.$route.query.amount
    }
    if (this.userInfo.roleId == 10){ //经销商
      this.isDealer = true
    }
    this.getkjtbankList()
  },
  mounted() {
    this.getpaycode()//扫码支付
    this.getUserMoney();
    this.orderGoodsInfo.forEach((item) => {
      this.midArr.push(item.bxmId)
      item.bxyCommodityList.forEach((goodsItem)=>{
          this.cidArr.push(goodsItem.id)
      })
      this.account += Number(item.amount);
    });

    this.bankCentent()

    this.getkjtEnableList()
    //   this.searchRedEnvelope()
    // this.getshoworderList()
    // this.getcheckPay();
  },
   beforeDestroy() {    //页面关闭时清除定时器
    clearInterval(this.clearTimeSet);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeCheck() {
      if (this.checked) {
        this.ruleForm.radio = "";
        this.fastChecked=false
      }
    },
    changeCheckRadio() {
      if (this.ruleForm.radio != "") {
        this.checked = false;
        this.fastChecked=false
      }
    },
    // 查询用户的有关金额
    getUserMoney() {
      getUserPay({
        userId: this.userInfo.userId,
      })
        .then((res) => {
          this.getUserPays = res.data;
        })
        .catch((err) => {
          this.$message.error("查询用户的有关金额失败，请稍后再试！");
        });
    },
    getSpecification(id) {
      let nameArr = [];
      getSpecificationselect({ specificationId: id })
        .then((res) => {
          if (res.code == 0) {
            res.rows.forEach((item) => {
              nameArr.push(item.bXyAttributeList[0].name);
            });
            //   this.getaddresslist()
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("删除失败，请稍后再试！");
        });
      return nameArr;
    },
    orderNows() {
      // checkPay({
      //   orderNumber: this.orderGoodsInfo[0].orderNumber,
      //   value: this.orderGoodsInfo[0].orderAmount,
      // }).then((res) => {
      //   console.log(res);
      //   if (res.code == 0) {
          const oidArr = []; // 订单id集合
          const outTradeNo = []; // 订单号集合
          this.orderGoodsInfo.forEach((item) => {
            oidArr.push(item.oid);
            outTradeNo.push(item.orderNumber);
          });
          if (this.ruleForm.radio == 1) {
            // 使用支付宝支付
            alipayPc({
              description: this.orderGoodsInfo[0].title,
              // 'goodsCode': this.orderGoodsInfo[0].oid, // 商品编号
              goodsTitle: this.orderGoodsInfo[0].title,
              // outTradeNo: this.orderGoodsInfo[0].orderNumber, // 订单号
              outTradeNo: outTradeNo.toString(), // 订单号
              // 'passbackParams': `${this.$baseUrl}/xunyou/myOrderRight?orderNumer=${this.orderGoodsInfo[0].orderNumber}`,
              passbackParams: `${this.$baseUrl}/custom/xunyou/xy_personvalue/api/deal`,
              storeId: this.orderGoodsInfo[0].bxmId, // 店铺id
              timeoutExpress: "30m",
              totalAmount: this.account,
            })
              .then((res) => {
                const payDiv = document.getElementById("payDiv");
                if (payDiv) {
                  document.body.removeChild(payDiv);
                }
                const div = document.createElement("div");
                div.id = "payDiv";
                div.innerHTML = res;
                document.body.appendChild(div);
                document
                  .getElementById("payDiv")
                  .getElementsByTagName("form")[0]
                  .submit();
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error("付款失败，请稍后再试！");
              });
          }else if (this.ruleForm.radio == 2) {
            // 使用微信支付
            alipayPcWX({
              description: this.orderGoodsInfo[0].title,
              // outTradeNo: this.orderGoodsInfo[0].orderNumber,
              outTradeNo: outTradeNo.toString(),
              // passbackParams: `${this.$baseUrl}/xunyou/myOrderRight?orderNumer=${this.orderGoodsInfo[0].orderNumber}`,
              passbackParams: `${this.$baseUrl}/custom/xunyou/xy_personvalue/api/deal?outTradeNo=${this.orderGoodsInfo[0].totalOrderNumber}`,
              totalAmount: this.account,
            })
              .then((res) => {
                this.$store.commit("getWxerweima", res.data.qrCodeUrl);
                setTimeout(() => {
                  this.$router.push(`/wxERweima?totalOrderNumber=${this.orderGoodsInfo[0].totalOrderNumber}&outBizNo=${res.data.out_order_no}`);
                }, 800);
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error("付款失败，请稍后再试！");
              });
          }else if (this.ruleForm.radio == 3) {
            // 使用通用二维码支付
            this.$router.push(`/generalCode`);
            //this.$router.push(`/generalCode?outTradeNo=${this.orderGoodsInfo[0].totalOrderNumber}&totalAmount=${this.account}`);

          }else if (this.ruleForm.radio == 4) {
            // 弹窗展示支付记录
            console.log('订单类型', this.orderGoodsInfo[0].orderType)
              if(this.orderGoodsInfo[0].orderType === 5) {

                this.payDialogVisible = true;
                // this.payMoneyAgain()
              } else {
                // 使用银行卡支付
                if(this.mergeFlag=="true"){
                  cloudBillOrderPayMerge({
                    outTradeNo:this.totalOrderNosMerge,
                    totalAmount:this.totalAmount
                  }).then(res => {
                    if(res.code==0){
                      //window.open("about:blank").location.href = res.data.thirdPayCode;
                      window.location.href = res.data.thirdPayCode;
                    }else{
                      this.$message.error(res.msg);
                    }

                  });
                }else{
                  cloudBillOrderPay({
                    outTradeNo:this.orderGoodsInfo[0].totalOrderNumber,
                    totalAmount:this.account
                  }).then(res => {
                    //window.open("about:blank").location.href = res.data.thirdPayCode;
                    window.location.href = res.data.thirdPayCode;
                  });
                }
              }
            // this.$router.push(`/generalCode?outTradeNo=${this.orderGoodsInfo[0].totalOrderNumber}&totalAmount=${this.account}`);
          } else if (this.checked) {
            //使用余额支付
            balancePay({
              isHybridPay: 2, //   是否是混合支付 1:是 2：否
              uid: this.userInfo.userId, //用户ID
              type: 2, // 交易类型
              statusType: 2, // 出账
              note: this.orderGoodsInfo[0].title,
              amount: this.account,
              pay_psw: this.ruleForm.pass,
              // oid: this.orderGoodsInfo[0].oid, //oidArr
              oid: oidArr.toString(), //oidArr
              // 如果请求里面需要加字段,需要去(xunyou.js)里接口配一个
            })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("付款成功");
                  this.$router.push(`/myOrderRight`);
                } else {
                  this.$message.error(res.msg);
                }
                this.loading = false;
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error("付款失败，请稍后再试！");
                setTimeout(() => {
                  this.$router.push("/paymentCenter");
                }, 800);
              });
          }
        // } else {
        //   this.$message({
        //     type: "error",
        //     message: res.msg,
        //   });
        // }
      // });
    },
    // 混合支付开启
    orderNowsmix() {
      // 获取余额支付比例
      getBalancePayProportion()
        .then((res) => {
          if (res.code == 0) {
            console.log(
              Number(res.msg) / 100,
              res.msg,
              "查询余额支付比例失败，请稍后再试！"
            );
            this.balanceRatio = Number(res.msg) / 100;
            this.balanceRatioPrice = (Number(res.msg) / 100) * this.account;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("查询余额支付比例失败，请稍后再试！");
        });
      this.centerDialogVisible = true;
    },
    //混合支付
    mixPay() {
      // checkPay({
      //   orderNumber: this.orderGoodsInfo[0].orderNumber,
      //   value: this.orderGoodsInfo[0].orderAmount,
      // }).then((res) => {
      //   if (res.code == 0) {
          // 判断输入的金额是否大于最大支付余额
          if (this.balencePay > this.balanceRatioPrice) {
            this.$message.error(`支付金额不能超过${this.balanceRatioPrice}`);
          } else {
            //判断是否选择了第二种支付方式
            if (
              this.ruleForm.radio != 3 &&
              this.ruleForm.radio != 4 &&
              this.balencePay < this.account
            ) {
              this.$message.error("请选择与微信/支付宝组合支付方式");
              return;
            }
            const oidArr = []; // 订单id集合
            const outTradeNo = []; // 订单号集合
            this.orderGoodsInfo.forEach((item) => {
              oidArr.push(item.oid);
              outTradeNo.push(item.orderNumber);
            });

            //使用混合支付
            balancePayMax({
              isHybridPay: 1, //   是否是混合支付 1:是 2：否
              uid: this.userInfo.userId, //用户ID
              type: 2, // 交易类型
              statusType: 2, // 出账
              note: this.orderGoodsInfo[0].title,
              amount: this.balencePay,
              pay_psw: this.ruleForm.pass,
              oid: outTradeNo.toString(),
              // oid: this.orderGoodsInfo[0].oid,
              // 如果请求里面需要加字段,需要去(xunyou.js)里接口配一个
            })
              .then((res) => {
                if (res.code == 0) {
                  //去支付宝混合
                  if (
                    this.ruleForm.radio == 3 &&
                    this.balencePay < this.account
                  ) {
                    alipayPc({
                      description: this.orderGoodsInfo[0].title,
                      goodsTitle: this.orderGoodsInfo[0].title,
                      outTradeNo: outTradeNo.toString(), // 订单号
                      passbackParams: `${this.$baseUrl}/custom/xunyou/xy_personvalue/api/dealMax`,
                      storeId: this.orderGoodsInfo[0].bxmId, // 店铺id
                      timeoutExpress: "30m",
                      totalAmount:
                        Number(this.account) - Number(this.balencePay),
                    })
                      .then((res) => {
                        const payDiv = document.getElementById("payDiv");
                        if (payDiv) {
                          document.body.removeChild(payDiv);
                        }
                        const div = document.createElement("div");
                        div.id = "payDiv";
                        div.innerHTML = res;
                        document.body.appendChild(div);
                        document
                          .getElementById("payDiv")
                          .getElementsByTagName("form")[0]
                          .submit();
                      })
                      .catch((err) => {
                        this.editFormVisible = false;
                        this.loading = false;
                        this.$message.error("付款失败，请稍后再试！");
                        setTimeout(() => {
                          this.$router.push("/paymentCenter");
                        }, 800);
                      });
                  }
                  //微信混合
                  else if (
                    this.ruleForm.radio == 4 &&
                    this.balencePay < this.account
                  ) {
                    // 使用微信支付
                    alipayPcWX({
                      description: this.orderGoodsInfo[0].title,
                      outTradeNo: outTradeNo.toString(),
                      passbackParams: `${this.$baseUrl}/xunyou/myOrderRight?orderNumer=${this.orderGoodsInfo[0].orderNumber}`,
                      totalAmount: (
                        Number(this.account) - Number(this.balencePay)
                      ).toFixed(2),
                    })
                      .then((res) => {
                        this.$store.commit("getWxerweima", res.data.qrCodeUrl);
                        setTimeout(() => {
                          this.$router.push(`/wxERweima?totalOrderNumber=${this.orderGoodsInfo[0].totalOrderNumber}&outBizNo=${res.data.out_order_no}`);
                        }, 800);
                      })
                      .catch((err) => {
                        this.editFormVisible = false;
                        this.loading = false;
                        this.$message.error("付款失败，请稍后再试！");
                      });
                  } else if (
                    this.ruleForm.radio != 4 &&
                    this.ruleForm.radio != 3
                  ) {
                    balancePay({
                      isHybridPay: 1, //   是否是混合支付 1:是 2：否
                      uid: this.userInfo.userId, //用户ID
                      type: 2, // 交易类型
                      statusType: 2, // 出账
                      note: this.orderGoodsInfo[0].title,
                      amount: this.balencePay,
                      pay_psw: this.ruleForm.pass,
                      oid: oidArr.toString(),
                      // oid: this.orderGoodsInfo[0].oid,
                      // 如果请求里面需要加字段,需要去(xunyou.js)里接口配一个
                    })
                      .then((res) => {
                        if (res.code == 0) {
                          this.$message.success("付款成功！");
                        } else {
                          this.$message.error(res.msg);
                        }
                        this.loading = false;
                      })
                      .catch((err) => {
                        this.editFormVisible = false;
                        this.loading = false;
                        this.$message.error("付款失败，请稍后再试！");
                      });
                  }
                } else {
                  this.$message.error(res.msg);
                }
                this.loading = false;
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error("付款失败，请稍后再试！");
              });
          }
        // }else{
        //    this.$message({
        //     type: "error",
        //     message: res.msg,
        //   })
        // }
      // });
    },

    // ========================= 快捷通 支付 开始 ==========================================

    // 获取银行列表
     getkjtbankList(){
      kjtbankList().then(res=>{
        if(res.code==0){
          this.navList = res.rows
        }
      })
    },

     // 获取快捷通 开关集合
    getkjtEnableList(){
      kjtEnable({
        mids:this.midArr,
        cIds:this.cidArr,
      }).then(res=>{
        if(res.code==0){
          this.kjtEnableObj = res.data
          this.$store.commit('getkjtEnable',res.data)
        }
      })
    },

    // 快捷通
    changeFastCheck(){
      if(this.fastChecked){
        this.openfastPay = '1'
        this.opencodePay = ''
        this.ruleForm.radio = "";
        this.checked = false
        this.codeChecked = false
      }else{
        this.openfastPay = ''
        this.opencodePay = ''
        this.codeChecked = false
        this.ruleForm.radio = ""; // 关闭支付宝支付
        this.checked = true
      }
    },
    // 二维码
    changecodeCheck(){
        if(this.codeChecked){
        this.repayWX() // 展开就调用二维码查询支付状态接口
        this.opencodePay = '1' // 打开二维码折叠面板
        this.openfastPay = ''
        this.ruleForm.radio = ""; // 关闭支付宝支付
        this.checked = false // 关闭余额
        this.fastChecked = false // 关闭快捷通
      }else{
        clearInterval(this.clearTimeSet);//关闭清除定时器
        this.openfastPay = ''
        this.opencodePay = ''
        this.ruleForm.radio = ""; // 关闭支付宝支付
        this.fastChecked = false
        this.checked = true
      }
    },
    changeBack(item,index){
      console.log(item,index)
      if(index > -1){
        this.ruleForm.radio = "";
        this.checked = false
      }
      this.bankCode = item.bankCode
    },
    bankCentent(){
      this.navList.map((item,index)=>{
            this.bankLists.push(item.bankList)
        })
    },
    handleSelect(key, keyPath) {
        // this.bankCentent()
        this.index = key
        if(key==1){
          this.payProductCode = 20
          console.log(this.payProductCode);
        }if(key==2){
          this.payProductCode = 31
          console.log(this.payProductCode);
        }if(key==3){
          this.payProductCode = 40
          console.log(this.payProductCode);
        }
        console.log(this.bankLists,'xxxx',this.index)
    },

    wangYing(){
      if(!this.modeKey){
        this.$message({
            type: "error",
            message: '请选择银行',
          })
          return
      }
      const oidArr = []; // 订单id集合
      const outTradeNo = []; // 订单号集合
      this.orderGoodsInfo.forEach((item) => {
        oidArr.push(item.oid);
        outTradeNo.push(item.orderNumber);
      });
      getZtPay({
        outTradeNo: outTradeNo.toString(),
        muId: this.userInfo.userId,
        payProductCode: this.payProductCode,
        bankCode: this.bankCode
      })
      .then(res => {
        if(res.code==0){
           var formStr = res.msg
          const payDiv = document.getElementById('payDiv');
          if (payDiv) {
            document.body.removeChild(payDiv);
          }
          const div = document.createElement('div');
          div.id = 'payDiv';
          div.innerHTML = formStr;
          document.body.appendChild(div);
          document.getElementById('payDiv')
                  .getElementsByTagName('form')[0]
                  .submit();
        }else{
           this.$message({
            type: "error",
            message: res.msg,
          })
        }

      })
      .catch(err=>{
        this.$message({
            type: "error",
            message: res.msg,
          })
      })
    },

  // 二维码
   // 二维码支付回调参数
      repayWX(){
        this.clearTimeSet=setInterval(() => {
          paycodeStatus({
            orderNum:this.orderGoodsInfo[0].orderNumber,
          })
          .then((res) => {
              if(res.code == 0){
                   this.$router.push('/myOrderRight')
              }
          })
        }, 3000);
      },
      clearTime(){ //清除定时器
        clearInterval(this.clearTimeSet);
      },
      getpaycode() {
        // checkPay({
        // orderNumber: this.orderGoodsInfo[0].orderNumber,
        // value: this.orderGoodsInfo[0].orderAmount,
        // }).then(res => {
          // if(res.code == 0){
            const oidArr = []; // 订单id集合
            const outTradeNo = []; // 订单号集合
            this.orderGoodsInfo.forEach((item) => {
              oidArr.push(item.oid);
              outTradeNo.push(item.orderNumber);
            });
              // 使用支付宝支付
              getZtAlipayPcPay({
                outTradeNo: outTradeNo.toString(),
                muId: this.userInfo.userId,
                source: "PC"
              })
                .then(res => {
                  console.log('111q')
                  if(res.code == 0){
                    this.zfbAlipay = true
                    this.$nextTick (()=>{
                        document.getElementById("qrcode").innerHTML = "";
                        new QRCode('qrcode', {
                            width: 200,
                            height: 200,
                            text: res.msg
                        })
                    })
                  }
                })
          // }
        // })
    },
    // ========================= 快捷通 支付 结束 ==========================================

    //   getshoworderList(){
    //     showorderList({

    //     })
    //         .then(res => {
    //             console.log('查询订单',res)
    //           if (res.code == 0) {
    //             //   this.loading = false
    //             //   this.envelopeList = res.rows;
    //           } else {
    //             this.$message({
    //               type: 'info',
    //               message: res.msg
    //             })
    //           }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('查询红包失败，请稍后再试！')
    //         })
    //   }
    // orderNow(){
    //     this.$refs.ruleForm.validate((valid) => {
    //       if (valid) {
    //         // alert('submit!');
    //         alipay({
    //             outTradeNo:'pp',
    //             subject:'11',
    //             totalAmount:'1'
    //         })
    //         .then(res => {
    //             // this.payPage = res
    //         //   if (res.code == 0) {
    //         //       this.dialogVisible = true
    //         //   } else {
    //         //     this.$message({
    //         //       type: 'info',
    //         //       message: '付款失败，请稍后再试！'
    //         //     })
    //         //   }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('付款失败，请稍后再试！')
    //         })
    //       } else {
    //         console.log('error submit!!');
    //         return false;
    //       }
    //     });
    // }

    // // 红包查询
    //   searchRedEnvelope() {
    //       this.loading = true
    //      redEnvelope()
    //         .then(res => {
    //           if (res.code == 0) {
    //               this.loading = false
    //               this.envelopeList = res.rows;
    //           } else {
    //             this.$message({
    //               type: 'info',
    //               message: res.msg
    //             })
    //           }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('查询红包失败，请稍后再试！')
    //         })
    // },
    payMoneyAgain() {
      if(this.unPayMoney <= 0) {
        this.$message.error('请输入正确金额！')
        return
      }
      cloudBillOrderPayV2({
        outTradeNo: this.orderGoodsInfo[0].orderNumber,
        totalAmount: this.unPayMoney,
        uid: JSON.parse(localStorage.getItem("userdata")).userId,
      }).then(res => {
        if (res.code == 0) {
          window.location.href = res.data.thirdPayCode;
        } else {
          this.$message.error(res.msg);
        }

      });
    },
  },
};
</script>

<style scoped lang="less">
// /deep/ .el-dialog__body {
//   padding: 20px 20px 100px;
// }
// .mixdialog {
//     height: 600px;
//   /deep/.el-dialog__body {
//       padding: 0 !important;
//   }
// }
.mixPayed {
  display: flex;
  justify-content: center;
  margin: 100px 0;
}
.orderSuccess {
  margin: 20px 0;
  background: white;
  padding: 30px 70px;
  font-size: 14px;
  .orderSuccess_icon {
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 40px;
    color: #83c44e;
    text-align: center;
    border: 2px solid #83c44e;
    border-radius: 42px;
  }
  .orderSuccess_tip {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #757575;
    .orderSuccess_text {
      margin-bottom: 10px;
      font-size: 24px;
      font-weight: 400;
    }
    .orderSuccess_price {
      font-size: 24px;
      color: #78b942;
    }
  }
  .address_info {
    margin: 20px 0;
  }
  /deep/.el-collapse {
    border-bottom: 0px !important;
  }
  /deep/.el-collapse-item__header {
    font-size: 14px;
  }
  span.text_width {
    width: 10%;
    display: inline-block;
  }
  .text_bgcolor {
    display: inline-block;
    width: 80%;
    background: #f5f5f5;
  }
  .order_detail {
    display: inline-block;
    position: absolute;
    right: 30px;
  }
  .payMethods {
    font-size: 18px;
    .payMethods_title {
      margin: 20px 0;
      padding-bottom: 20px;
      border-bottom: 1px solid #ccc;
    }
    .checked_free {
      padding: 10px;
      color: #666;
      font-size: 14px;
      border: 1px solid #e7e7e7;
      margin: 20px 0;
    }
    .payMethods_img {
      // margin: 20px;
      border: 1px solid #ccc;
    }
  }

  button.el-button.buttonBgd.el-button--primary {
    background-color: #78b942;
    border-color: #78b942;
    font-size: 14px;
    margin: 20px 0;
  }
  .textCenter {
    text-align: center;
    font-size: 25px;
  }
}
.mixdialog {
  /deep/.el-button.buttonBgd.el-button--primary {
    background-color: #78b942 !important;
    border-color: #78b942 !important;
  }
}
.fastPay{
  /deep/.buttonBgd {
    background-color: #78b942;
    border-color: #78b942;
    font-size: 14px;
    margin: 20px 0;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/shoppingcart/orderNow.vue